var _circle, _circle2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBhiTreeDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 146,
    viewBox: "0 0 138 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6078_57006)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.1824,
    cy: 72.6976,
    r: 64.4715,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6078_57006",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 131,
    height: 130
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.5108,
    cy: 64.7686,
    r: 59.7686,
    fill: "white",
    stroke: "white",
    strokeWidth: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6078_57006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.1154 85.6139C86.0471 85.523 85.9613 85.4466 85.8632 85.389C85.7652 85.3314 85.6567 85.2938 85.544 85.2784C85.4313 85.263 85.3166 85.27 85.2066 85.2992C85.0967 85.3283 84.9936 85.3789 84.9033 85.4481L70.0197 96.8229V81.5629C70.089 81.4356 70.1252 81.2931 70.1252 81.1482C70.1252 81.0034 70.089 80.8608 70.0197 80.7336V42.8515C70.0197 42.6214 69.9283 42.4007 69.7656 42.238C69.6029 42.0753 69.3822 41.9839 69.1521 41.9839C68.922 41.9839 68.7013 42.0753 68.5386 42.238C68.3759 42.4007 68.2845 42.6214 68.2845 42.8515V79.3173L53.6114 68.1402C53.4277 68.0217 53.206 67.9769 52.9907 68.0148C52.7753 68.0527 52.5823 68.1705 52.4501 68.3447C52.3178 68.5188 52.2562 68.7364 52.2776 68.954C52.2989 69.1716 52.4016 69.3731 52.5651 69.5182L68.2845 81.5119V117.41L53.6114 106.233C53.4277 106.114 53.206 106.07 52.9907 106.107C52.7753 106.145 52.5823 106.263 52.4501 106.437C52.3178 106.611 52.2562 106.829 52.2776 107.047C52.2989 107.264 52.4016 107.466 52.5651 107.611L68.2781 119.592V121.907C68.2781 122.138 68.3695 122.358 68.5322 122.521C68.6949 122.684 68.9156 122.775 69.1457 122.775C69.3758 122.775 69.5965 122.684 69.7592 122.521C69.9219 122.358 70.0133 122.138 70.0133 121.907V98.9664L85.9623 86.8452C86.055 86.7758 86.1328 86.6883 86.1909 86.5882C86.2491 86.488 86.2864 86.3771 86.3007 86.2621C86.315 86.1472 86.306 86.0305 86.2741 85.9192C86.2423 85.8078 86.1883 85.704 86.1154 85.6139Z",
    fill: "#479AD0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M69.5156 70.5327C84.4273 70.5327 96.5156 58.4444 96.5156 43.5327C96.5156 28.621 84.4273 16.5327 69.5156 16.5327C54.6039 16.5327 42.5156 28.621 42.5156 43.5327C42.5156 58.4444 54.6039 70.5327 69.5156 70.5327Z",
    fill: "#C4D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M52.7109 93.9707C67.6226 93.9707 79.7109 81.8824 79.7109 66.9707C79.7109 52.059 67.6226 39.9707 52.7109 39.9707C37.7992 39.9707 25.7109 52.059 25.7109 66.9707C25.7109 81.8824 37.7992 93.9707 52.7109 93.9707Z",
    fill: "#C4D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.7422 113.27C56.565 113.27 59.664 110.171 59.664 106.349C59.664 102.526 56.565 99.4268 52.7422 99.4268C48.9193 99.4268 45.8203 102.526 45.8203 106.349C45.8203 110.171 48.9193 113.27 52.7422 113.27Z",
    fill: "#C4D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M86.0469 109.598C100.959 109.598 113.047 97.5098 113.047 82.5981C113.047 67.6865 100.959 55.5981 86.0469 55.5981C71.1352 55.5981 59.0469 67.6865 59.0469 82.5981C59.0469 97.5098 71.1352 109.598 86.0469 109.598Z",
    fill: "#C4D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3965 138.406C85.9069 137.914 85.8941 137.653 85.3965 137.162C80.9265 132.747 76.497 128.309 72.1078 123.847C71.54 123.273 71.2466 123.331 70.7171 123.847C65.9324 128.721 61.103 133.506 56.3183 138.335C55.7952 138.865 55.5017 138.973 54.9339 138.374C53.0647 136.415 51.1062 134.546 49.237 132.6C48.599 131.918 48.3821 132.275 48.0376 132.817C47.6931 133.359 48.1078 133.487 48.3502 133.729C50.4874 135.886 52.6628 138.004 54.7617 140.192C55.3996 140.83 55.7314 140.938 56.4395 140.192C61.2051 135.337 66.0089 130.54 70.8255 125.717C71.2083 125.327 71.4635 125.142 71.9292 125.64C75.7569 129.532 79.6209 133.404 83.5209 137.257C83.9292 137.659 83.9165 137.895 83.5209 138.272C82.4236 139.35 81.3391 140.434 80.2546 141.519H82.1684C83.253 140.481 84.329 139.443 85.3965 138.406Z",
    fill: "#479AD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7273 130.374C71.2887 129.807 71.5885 129.813 72.118 130.374C73.1579 131.504 74.2807 132.556 75.3525 133.654C75.7225 134.03 75.9904 134.349 76.5391 133.781C77.0877 133.213 76.7113 133.009 76.386 132.684C74.9697 131.268 73.5215 129.883 72.1563 128.416C71.5758 127.778 71.2632 127.848 70.6826 128.416C66.3445 132.811 61.9808 137.169 57.6172 141.532H59.5949C63.312 137.824 67.0228 134.104 70.7273 130.374Z",
    fill: "#479AD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9378 123.913L58.9297 123.905L58.9378 123.913Z",
    fill: "#479AD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9383 135.86C55.4806 136.434 55.7677 136.345 56.2716 135.86C60.6608 131.426 65.0819 127.018 69.4902 122.603C69.6752 122.425 69.9304 122.291 69.9686 121.965C69.5011 121.805 68.9952 121.793 68.5209 121.933C68.0467 122.072 67.6274 122.356 67.3211 122.744C63.6592 126.488 59.9208 130.157 56.2334 133.876C55.7549 134.361 55.4614 134.444 54.9574 133.876C54.2746 133.097 53.5415 132.364 52.7629 131.681C52.1249 131.126 52.0803 130.788 52.7629 130.144C54.849 128.083 56.9989 126.086 58.9383 123.885L59.0723 123.803L58.9766 123.726L58.9001 123.847C57.4449 124.217 56.1065 124.948 55.0085 125.972C53.5093 127.401 52.1058 128.919 50.6002 130.342C50.0771 130.833 50.2047 131.088 50.6385 131.509C52.093 132.951 53.5476 134.38 54.9383 135.86Z",
    fill: "#479AD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7892 135.873C87.1401 136.23 87.3697 136.511 87.8992 136.013C88.4288 135.515 88.1289 135.209 87.7589 134.845C85.1624 132.255 82.5914 129.646 79.9822 127.075C79.4782 126.584 79.2103 126.214 79.9184 125.697C80.1098 125.557 80.5563 125.353 80.2629 125.014C79.9889 124.777 79.6635 124.607 79.3123 124.517C79.1273 124.453 77.3984 126.156 77.3984 126.431C77.5133 126.558 77.66 126.737 77.8195 126.896C80.8094 129.886 83.7993 132.878 86.7892 135.873Z",
    fill: "#479AD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0874 130.419C54.6344 130.872 54.7046 131.101 55.0874 131.529C55.4702 131.956 55.7891 131.72 56.1081 131.401C59.0172 128.475 61.9306 125.551 64.8482 122.629C64.9821 122.502 65.1927 122.406 65.1671 122.049C64.3059 122.221 63.4064 122.049 62.6982 122.789C60.1911 125.347 57.6711 127.899 55.0874 130.419Z",
    fill: "#479AD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0625 126.342C84.1805 128.448 86.3496 130.617 88.4868 132.754C87.4277 130.559 83.2363 126.432 82.0625 126.342Z",
    fill: "#479AD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2566 124.39C75.8116 125.13 76.271 125.028 76.7686 124.39C76.8952 124.237 77.0339 124.094 77.1833 123.963C77.4257 123.714 77.3236 123.567 77.0365 123.471C75.8882 123.108 74.7973 122.54 73.5469 122.546C73.9807 123.267 74.7526 123.714 75.2566 124.39Z",
    fill: "#479AD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5002 122.484L73.4609 122.419C73.4609 122.419 73.4609 122.458 73.4609 122.471L73.5002 122.484Z",
    fill: "#479AD0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6078_57006",
    x: 0.710938,
    y: 8.22607,
    width: 136.945,
    height: 136.943,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6078_57006"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6078_57006",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhiTreeDisabled);
export default __webpack_public_path__ + "static/media/bhi-tree-disabled.fc429fcd.svg";
export { ForwardRef as ReactComponent };